import { PageProps } from 'gatsby'
import React, { useEffect } from 'react'
import BuilderPage from './BuilderPage.experiment'
import DynamicPage from './DynamicPage.experiment'
import { ABContainer, PageExperimentWrapper } from './ExperimentPageContainer.styles'

const ExperimentPageContainer = (props: PageProps): JSX.Element => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const bHistorySet = new Set(JSON.parse(window.localStorage.getItem('path_history') || '[]'))
      bHistorySet.add(window.location.pathname.split('/').join('_'))
      window.localStorage.setItem('path_history', JSON.stringify([ ...bHistorySet ]));
    }
  }, [])

  return (
    <PageExperimentWrapper>
      <ABContainer id="builder-page-experiment-a" visible={false}>
        <BuilderPage {...props} />
      </ABContainer>
      <ABContainer id="builder-page-experiment-b" visible={false}>
        <DynamicPage {...props} />
      </ABContainer>
    </PageExperimentWrapper>
  )
}

export default ExperimentPageContainer;
